import { Buffer } from 'buffer';

export const decodeJwt = <T>(token: string): T | null => {
  try {
    const base64Content = Buffer.from(token.split('.')[1], 'base64');
    return JSON.parse(base64Content.toString());
  } catch (e) {
    return null;
  }
};
